module.exports = __webpack_public_path__ + "img/login.08f8ec2f.png";